export enum CategoriesEndpointsEnum {
  HOME_CATEGORIES = "/homepageCategories",
}
